<span class="field-view-value">{{formattedDate || '—'}}</span>
